// extracted by mini-css-extract-plugin
export default {"coins":"Qn8XKr3F7fjt1ymO0W4r"};